import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-modal-pengkiniandata',
    templateUrl: './modal-pengkiniandata.component.html',
    styleUrls: ['./modal-pengkiniandata.component.scss'],
    standalone: false
})
export class ModalPengkiniandataComponent implements OnInit {

   constructor(
     public dialogRef: MatDialogRef<ModalPengkiniandataComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any
   ) { }

  ngOnInit() {
  }

  closeDialog() {
    try { 
      this.dialogRef.close('close'); 
    } 
    catch (error) { 
      console.error('Error closing dialog:', error); 
    }
  }

}
